import differenceInYears from 'date-fns/differenceInYears';
import isLeapYear from 'date-fns/isLeapYear';
import setYear from 'date-fns/setYear';

type CheckFunction = typeof Math.max | typeof Math.min;

const isValidAge = (checker: CheckFunction) => (
  requiredAge: number,
  currentAge: number
): boolean => {
  const targetNumber = requiredAge;
  const sourceNumber = currentAge;
  const result = checker(targetNumber, sourceNumber);
  return !(result === targetNumber);
};

const getDateParts = (currentDate: string): number[] => {
  const [day, month, year] = currentDate.split('/');
  return [parseInt(day, 10), parseInt(month, 10), parseInt(year, 10)];
};

const getDate = (currentDate: string): Date => {
  const [day, month, year] = getDateParts(currentDate);
  return new Date([month, day, year].join('/'));
};

const getAge = (currentDate: string) => {
  const date = getDate(currentDate);
  const today = new Date();
  return differenceInYears(today, date);
};

const ageChecker = (
  currentDate: string,
  ageCondition: number,
  checker: CheckFunction
): boolean => {
  const targetNumber = Number(ageCondition);
  const age = getAge(currentDate);

  return isValidAge(checker)(targetNumber, age);
};

const isValidDate = (currentDate: string): boolean => {
  const [day, month, year] = getDateParts(currentDate);

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return false;
  }

  const date = setYear(getDate(currentDate), year);
  const monthLength = [
    31,
    isLeapYear(date) ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ];

  return day > 0 && day <= monthLength[month - 1];
};

export { ageChecker, getAge, isValidDate };
